import React, { useState, useEffect } from 'react'
import Button from 'srcReact/components/common2/Button'
import Dropdown1 from 'srcReact/components/common2/Dropdown1'
import Spinner from 'srcReact/components/common2/Spinner'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { createUpdateGroupActions } from 'srcReact/GroupPage'
import colorVariables from 'srcReact/assets/scss/global/base/_variables.scss'

export default function MemberSettings({
  value,
  editMode,
  containerCSS,
  titleCSS,
  infoCSS,
  optionsContainCSS,
  dropdownContainerCSS,
  dropdownLabelCSS,
  dropdownSelectedItemCSS,
  buttonWrapperCSS
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const {
    createUpdateGroup: { privacySetting }
  } = useSelector((state) => state)

  const [ageItems, setAgeItems] = useState([
    {
      value: 13,
      label: t('group.createGroup.advanceSetting.member.ageOption1')
    },
    {
      value: 18,
      label: t('group.createGroup.advanceSetting.member.ageOption2')
    },
    {
      value: 21,
      label: t('group.createGroup.advanceSetting.member.ageOption3')
    }
  ])

  const [selectedAge, setSelectedAge] = useState({
    value: 13,
    label: t('group.createGroup.advanceSetting.member.ageOption1')
  })
  const [memberSettingsUpdated, setMemberSettingsUpdated] = useState(false)
  const [memberSetting, setMemberSetting] = useState(value)
  const { loading, groupInfo, editSuccess } = useSelector((state) => state.createUpdateGroup)

  useEffect(() => {
    if (editMode && editSuccess) {
      if (memberSettingsUpdated) {
        setMemberSettingsUpdated(false)
      }
    }
  }, [editSuccess])

  useEffect(() => {
    setMemberSetting({ ...value })
    updateAge(ageItems.filter((a) => a.value === value.age))
  }, [value])

  const updateAge = (selectedAge) => {
    setSelectedAge(selectedAge)
    setMemberSetting({ ...memberSetting, age: selectedAge.value })
  }

  const handleSave = () => {
    dispatch(
      createUpdateGroupActions.editGroup(groupInfo.id, {
        privacy_setting: privacySetting,
        age_requirements: memberSetting.age
      })
    )
  }
  const handleCancel = () => {
    updateAge(ageItems.filter((a) => a.value === groupInfo.age_requirements))

    setMemberSetting({ age: groupInfo.age_requirements })
    setMemberSettingsUpdated(false)
  }

  const handleAgeChange = (selectedAge) => {
    updateAge(selectedAge)
    setMemberSettingsUpdated(true)
  }

  useEffect(() => {
    dispatch(createUpdateGroupActions.setMemberSetting({ ...memberSetting }))
  }, [memberSetting, dispatch])
  return (
    <div className={containerCSS}>
      <h2 className={titleCSS}>{t('group.createGroup.advanceSetting.member.title')}</h2>
      <p className={infoCSS}>{t('group.createGroup.advanceSetting.member.info')}</p>
      <div className={optionsContainCSS}>
        <div className={dropdownContainerCSS}>
          <label className={dropdownLabelCSS}>{t('group.createGroup.advanceSetting.member.ageRequirements')}</label>
          <Dropdown1
            isDisabled={editMode && groupInfo && groupInfo.members_number > 1}
            value={selectedAge}
            options={ageItems}
            className={dropdownSelectedItemCSS}
            onChange={handleAgeChange}
            isSearchable={false}
          />
        </div>
      </div>
      {editMode && memberSettingsUpdated && (
        <div className={buttonWrapperCSS}>
          <Button style='tertiary' type='button' handleClick={handleCancel} text={t('global.cancel')} />
          <Button
            type='button'
            handleClick={handleSave}
            text={loading ? <Spinner isWhite={true} /> : t('global.save')}
          />
        </div>
      )}
    </div>
  )
}
